import React from 'react';

import SkeletonElement from '../../../skeleton-element/skeleton-element';

import './loading-block.scss';

interface LoadingBlockProps {
  className?: string;
}

function LoadingBlock(props: LoadingBlockProps) {
  const { className } = props;

  return (
    <div className={className} styleName="container">
      <SkeletonElement />
      <SkeletonElement />
      <SkeletonElement />
      <SkeletonElement />
    </div>
  );
}

export default LoadingBlock;
